import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-936fd434"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_3 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "ant-col" }
const _hoisted_6 = { class: "ant-row ss-grade-personalizada-titulo ss-ocultar-mobile" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Modelo")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Chave de Acesso")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_13 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "ant-col"
}
const _hoisted_16 = { class: "ss-margin-campos" }
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_modelo_documento_fiscal = _resolveComponent("selecionar-modelo-documento-fiscal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, {
              label: "Modelo",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_modelo_documento_fiscal, {
                  valor: _ctx.state.modeloSelecionado,
                  "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.modeloSelecionado) = $event)),
                  disabled: !_ctx.props.editavel
                }, null, 8, ["valor", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "Chave de Acesso",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.chaveAcessoSelecionada) = $event)),
                  disabled: !_ctx.props.editavel
                }, null, 8, _hoisted_4), [
                  [_vModelText, _ctx.state.chaveAcessoSelecionada]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "top",
                  title: "Adicionar Documento"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.adicionarDocumento && _ctx.adicionarDocumento(...args)))
                    }, "Adicionar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      (_ctx.props.editavel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    (_ctx.computedDocumentos.length <= 0)
      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
          key: 1,
          mensagem: "Nenhum documento referenciado adicionado ainda"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.computedDocumentos, (documento, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ant-row",
            style: {"margin":"2px 5px"},
            key: index
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_form_item, {
                label: _ctx.state.telaMobile ? 'Modelo' : '',
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_modelo_documento_fiscal, {
                    valor: documento.modelo,
                    disabled: true
                  }, null, 8, ["valor"])
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_form_item, {
                label: _ctx.state.telaMobile ? 'Chave de Acesso' : '',
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: documento.chaveAcesso,
                    disabled: ""
                  }, null, 8, _hoisted_14)
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            (_ctx.props.editavel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary",
                      onClick: ($event: any) => (_ctx.removerDocumento(index))
                    }, [
                      _createVNode(_component_icone, {
                        class: "ss-icone-remover",
                        nome: "excluir"
                      })
                    ], 8, _hoisted_17)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
  ], 64))
}